"use client";

import FeatureModule from "@/app/(core)/(other)/about/components/feature/FeatureModule";
import PageSection, {
  PageSectionVariant,
} from "@/app/(core)/components/PageSection";
import SectionHeader from "@/app/(core)/components/SectionHeader";
import { Box } from "@mantine/core";
import classes from "./why-were-different-section.module.css";

interface WhyWereDifferentSectionProps {
  title?: string;
  subTitle?: string;
  firstSection?: boolean;
  variant?: PageSectionVariant;
}

export default function WhyWereDifferentSection({
  title,
  subTitle,
  firstSection = false,
  variant = "dark",
}: WhyWereDifferentSectionProps) {
  return (
    <PageSection variant={variant} firstSection={firstSection}>
      <SectionHeader
        title={title ?? "Why We're Different."}
        subTitle={
          subTitle ??
          "Highest-quality IB science resources - no AI, no shortcuts. Expertly crafted material used at 500+ IB schools worldwide."
        }
        align="center"
        needsLightTitle={variant === "dark"}
        isFirstSection
      />
      <Box className={classes.featureGridWrap}>
        <FeatureModule />
      </Box>
    </PageSection>
  );
}
